var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-auth-container h-100 d-flex align-items-center justify-content-center"},[_c('h2',[_vm._v("Page doesn't exist")])])}]

export { render, staticRenderFns }